import React from 'react'
import store from '../init/store'
import {timeout} from '../battle/ArenaView/animation-components/animation-lifecycle-utilities'
import audioManager from '../_audio/audio-manager'

class BrandingIntroScreen extends React.Component {

  constructor() {
    super();
    this.state = {
      step: 0
    }
  }

  componentDidMount() {
    this.runAnimationSteps()
  }

  async runAnimationSteps() {

    await timeout(600);

    audioManager.playSfx("sfx_jump")
    this.setState({
      step: 1
    });


    await timeout(800);
    this.setState({
      step: 0
    });

    await timeout(200);

    //Call our finisher function to notify App.js that we're ready to move on
    this.props.onFinish();
  }



  renderContent() {
    const viewportMode = store.getState().global.viewportMode;
    const style = {
      container: {
        display: "flex",
        alignItems: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%,-50%)",
        fontSize: viewportMode === "portrait" ? "1.4em" : "1em"
      },
      character: {
        width: "2em",
        height: "2em",
        marginRight: "0.2em",
        background: "url(/images/skins/m-3-front.svg) no-repeat no-repeat",
        backgroundSize: "cover",
        opacity: this.state.step >= 1 ? "1" : "0"
      },
      textContainer: {
        color: "#F0F5F7",
        fontSize: "0.7em"
      },
      theSpan: {
        display: "block",
        fontSize: "0.7em",
        margin: "0.1em 0",
        opacity: this.state.step >= 1 ? "1" : "0"
      },
      titleSpan: {
        display: "block",
        margin: "0.2em 0",
        opacity: this.state.step >= 1 ? "1" : "0"
      },



    };

    return (
      <div style={style.container}>
        <div style={style.character}>
        </div>
        <div style={style.textContainer}>
          <span style={style.theSpan}>THE</span>
          <span style={style.titleSpan}>DANGER</span>
          <span style={style.titleSpan}>CREW</span>
        </div>

      </div>
    )


  }


  render() {
    const style = {
      background: `#151825 radial-gradient(50% 105%, rgba(40,48,79,0.00) 52%, rgba(11,15,32,0.70) 100%)`,
      height: "100%"
    };

    return (
      <div style={style}>
        {this.renderContent()}
      </div>
    );
  }
}

export default BrandingIntroScreen;


// WEBPACK FOOTER //
// ./src/branding-intro/BrandingIntroScreen.js